import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ErrorTooltipComponent } from './error-tooltip/error-tooltip.component';
import { GlobalLoaderComponent } from './global-loader/global-loader.component';
import { ToastrModule } from 'ngx-toastr';import { PageHeaderComponent } from './page-header/page-header.component';
import { PaginationComponent } from './pagination/pagination.component';
import { ValuelistSelectorComponent } from './valuelist-selector/valuelist-selector.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ChatBotComponent } from './chat-bot/chat-bot.component';
import { CalendarComponent } from './calender/calendar.component';
import { ViewOnMapComponent } from './view-on-map/view-on-map.component';
import { NumericDirective } from './validators/numericvalue.directive';
import { AadhaarFormatDirective } from './validators/adhaarFormat.directive';
import { PanFormatDirective } from './validators/panFormat.directive';
import { IfscInputDirective } from './validators/ifscFormat.directive';
import { BulkUploadComponent } from './bulk-upload/bulk-upload.component';
import { IndianCurrencyPipe } from './CustomPipe/indianCurrencyPipe';
import { DocPreviewModalComponent } from './doc-preview-modal/doc-preview-modal.component';
import { ExcelPreviewComponent } from './excel-preview/excel-preview.component';
import { DiscussionComponent } from './discussion/discussion.component';
import { SafeUrlPipe } from './CustomPipe/safeUrlPipe';
import { UserCredentialModalComponent } from './user-credential-modal/user-credential-modal.component';
import { QuillEditorComponent } from './quill-editor/quill-editor.component';
import { HrmsReportingManagementComponent } from './hrms-reporting-management/hrms-reporting-management.component';
import { SupportActionComponent } from './support-action/support-action.component';
import { OnboardingRequestsComponent } from '../Common/onboarding-requests/onboarding-requests.component';

@NgModule({
  declarations: [
    GlobalLoaderComponent,
    ErrorTooltipComponent,
    PageHeaderComponent,
    PaginationComponent,
    ValuelistSelectorComponent,
    ChatBotComponent,
    CalendarComponent,
    ViewOnMapComponent,
    NumericDirective,
    AadhaarFormatDirective,
    PanFormatDirective,
    IfscInputDirective,
    BulkUploadComponent,
    IndianCurrencyPipe,
    DocPreviewModalComponent,
    ExcelPreviewComponent,
    DiscussionComponent,
    SafeUrlPipe,
    UserCredentialModalComponent,
    QuillEditorComponent,
    HrmsReportingManagementComponent,
    SupportActionComponent,
    OnboardingRequestsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule,
    NgSelectModule,
    NgxSkeletonLoaderModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
  ],
  exports: [
    GlobalLoaderComponent,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgbModule,
    NgxSkeletonLoaderModule,
    ErrorTooltipComponent,
    CommonModule,
    ToastrModule,
    PageHeaderComponent,
    PaginationComponent,
    ValuelistSelectorComponent,
    ChatBotComponent,
    CalendarComponent,
    NgSelectModule,
    ViewOnMapComponent,
    NumericDirective,
    AadhaarFormatDirective,
    PanFormatDirective,
    IfscInputDirective,
    BulkUploadComponent,
    ExcelPreviewComponent,
    IndianCurrencyPipe,
    DocPreviewModalComponent,
    DiscussionComponent,
    SafeUrlPipe,
    UserCredentialModalComponent,
    QuillEditorComponent,
    HrmsReportingManagementComponent,
    SupportActionComponent,
    OnboardingRequestsComponent
  ]
})
export class SharedModule { }
